// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s_Om","select":"styles_select__2Ljvo"};